
import Vue from "vue";
import Component from "vue-class-component";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";
import {
    OrganizationActions,
    OrganizationDetailsModel,
    OrganizationsClient,
} from "@/api-client";
import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import {Prop} from "vue-property-decorator";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
import PopoverInfo from "@/components/PopoverInfo.vue";
import OrganizationDetails from "@/features/organizations/views/OrganizationDetails.vue";
import {NavigationGuardNext} from "vue-router/types/router";

enum IdentifierType {
    Username = 1,
    PersonalCode
}

interface Props {
    preloadedOrganization: OrganizationDetailsModel;
    availableActions: OrganizationActions;
}

@Component({
    components: {
        LabelOptional,
        SectionPageHeading,
        HeadingGroup,
        ButtonWithConfirm,
        HeadingWave,
        TableEmptySlot,
        PopoverInfo,
        OrganizationDetails
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<RepresentativeOrganization>) {
        const props = to.meta!.props as Props;
        const organizationId = to.params.organizationId;
        Promise.all([
            new OrganizationsClient().details(organizationId),
            new OrganizationsClient().availableActions(organizationId)
        ]).then(values => {
            props.preloadedOrganization = values[0];
            props.availableActions = values[1];
            next();
        }).catch(e => next(e))
    }
})
export default class RepresentativeOrganization extends Vue implements Props {
    @Prop({required: true})
    preloadedOrganization!: OrganizationDetailsModel;
    @Prop({required: true})
    availableActions!: OrganizationActions;
}
